/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { ErrorCodes } from '@cedalo/parser';

import en from './en.json';
import de from './de.json';
// for testing purposes
// import deExt from '../../../../../packages/webui-extensions/src/languages/de.json';

const ParserCodes = {
	[ErrorCodes.EXPECTED_SEPARATOR]: 'Parser.Error.Expected.Separator',
	[ErrorCodes.EXPECTED_EXPRESSION]: 'Parser.Error.Expected.Expression',
	[ErrorCodes.EXPECTED_BRACKET_LEFT]: 'Parser.Error.Expected.BracketLeft',
	[ErrorCodes.EXPECTED_BRACKET_RIGHT]: 'Parser.Error.Expected.BracketRight',
	[ErrorCodes.EXPECTED_QUOTE]: 'Parser.Error.Expected.Quote',
	[ErrorCodes.MISSING_OPERAND]: 'Parser.Error.Missing.Operand',
	[ErrorCodes.UNEXPECTED_CHAR]: 'Parser.Error.Unexpected.Char',
	[ErrorCodes.UNKNOWN_FUNCTION]: 'Parser.Error.Unknown.Function',
	[ErrorCodes.UNKNOWN_IDENTIFIER]: 'Parser.Error.Unknown.Identifier'
};
export const getParserErrorMessage = (msg) => ({
	id: ParserCodes[msg.code],
	defaultMessage: msg.message,
	value: msg.value ? `"${msg.value}"`: ''
});

const defLocale = () => {
	let lang = window.navigator.userLanguage || window.navigator.language;
	if (lang.indexOf('-') !== -1) {
		// eslint-disable-next-line prefer-destructuring
		lang = lang.split('-')[0];
	}
	if (lang.indexOf('_') !== -1) {
		// eslint-disable-next-line prefer-destructuring
		lang = lang.split('_')[0];
	}
	return lang;
};

export const DEFAULT_LOCALE = defLocale() || 'en';

export const messages = {
	// de: {...de, ...deExt},
	de,
	en
};
